import { Select } from 'antd';
import styled from 'styled-components';

const { Option } = Select;

export const StyledAppSelect = styled(Select)`
  cursor: pointer;
  min-width: 184px;
  font-size: ${({ theme }) => theme.font.size.base};
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};

  &.ant-select.ant-select-outlined:not(
      .ant-select-customize-input
    ).ant-select-single
    .ant-select-selector {
    border-color: ${({ theme }) => theme.palette.neutral[300]};
  }

  &:hover,
  &:focus,
  &:active,
  &.ant-select-focused {
    .ant-select-selector {
      box-shadow: none !important;
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    }
  }

  &.ant-select-disabled {
    .ant-select-selection-item {
      color: ${({ theme }) => theme.palette.text.primary} !important;
      -webkit-text-fill-color: ${({ theme }) =>
        theme.palette.text.primary} !important;
    }

    /* antd dims the placeholder to near-invisible when disabled; keep the
       hint readable (e.g. Tax Period before a pay frequency is chosen). */
    .ant-select-selection-placeholder {
      color: ${({ theme }) => theme.palette.neutral[300]} !important;
      -webkit-text-fill-color: ${({ theme }) =>
        theme.palette.neutral[300]} !important;
    }

    &:hover,
    &:focus,
    &:active {
      .ant-select-selector {
        border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
      }
    }
  }

  &.ant-select-single.ant-select-lg {
    width: 100%;
    font-size: ${({ theme }) => theme.font.size.base};
    &.search-select {
      width: 320px;
    }
  }
`;

export const StyledOption = styled(Option)`
  cursor: pointer;
  padding: 8px;
  font-size: ${({ theme }) => theme.font.size.base};
`;
